import {DISTRIBUTION_CONSTANTS} from '../../../../../constants/distribution.constants';
import ViewModes from '../../../../../core/enums/view-modes.types';
import BundleCreationModel from '../../../../../core/models/distribution/BundleCreationModel';
import ContentLayoutComponent from '../../../../../layouts/content/component/content.layout.component';
import BundleVersionComponent from '../version/bundle.version.component';
import BundleVersionDAO from '../version/DAO/BundleVersionDAO';
import CreateBundleController from './bundle.create.controller';

export default class EditBundleComponent {
	constructor() {
		this.template = require('./bundle.create.view.html');
		this.controller = CreateBundleController;
		this.bindings = {
			bundle: '<',
			viewMode: '<',
		};
	}
}

EditBundleComponent.META = {
	name: 'editBundle',
	state: {
        isDistributionState: true,
        name: 'editBundle',
		url: '/bundles/source/:bundle/:version/edit',
        params: {prevUrl: null},
        template: '<edit-bundle bundle="$resolve.bundle" view-mode="$resolve.viewMode" ></edit-bundle>',
		parent: ContentLayoutComponent.META.state,
		resolve: {
			viewMode: () => ViewModes.EDIT,
			bundleVersionDAO: BundleVersionDAO.META.name,
			bundle: (bundleVersionDAO, $stateParams, $state, $q) => {
				let deferred = $q.defer();
				const canCreateReleaseBundle = window.store.getters['common/context/GET_CAN_CREATE_BUNDLE'];
                const routes = window.store.getters["distribution/GET_ROUTE_CONSTANTS"];
                if(!canCreateReleaseBundle){
                    window.$vueRouter.push({
                        name: routes.DISTRIBUTION_MAIN,
                        params: {activeTab: 'source'}
                    });
                    deferred.reject();
                }
				// Resolve Rb data by name from backend , else create new empty RB
				if ($stateParams.bundle && $stateParams.version) {
					bundleVersionDAO.Resource.getReleaseBundleVersion({
                        release_bundle:$stateParams.bundle,
                        release_bundle_version:$stateParams.version})
                        .$promise.then((response) => {
						if(response.state !== DISTRIBUTION_CONSTANTS.BUNDLE_VERSION_STATES.OPEN) {
							deferred.reject();
							$state.go(BundleVersionComponent.META.state.name,{bundle:$stateParams.bundle,version:$stateParams.version});
							return deferred.promise;
						}
						let bundleData = _.extend(angular.copy(response),{
							name: $stateParams.bundle ,
							version: $stateParams.version
						});
						deferred.resolve(new BundleCreationModel(bundleData));
					}, (response) => {
						if (response.status === 404 || response.status === 403) {
                            window.$vueRouter.push({name:'404'});
                            deferred.reject();
						}
					});
				} else {
					deferred.reject();
                    window.$vueRouter.push({name:'404'});
					return deferred.promise;
				}
				return deferred.promise;
			}
		}
	}
};



// WEBPACK FOOTER //
// ./modules/distribution/modules/distribution/components/bundle/create/bundle.edit.component.js